import './css/style.css';
import Home from './page/Home';
import 'remixicon/fonts/remixicon.css'
import { BrowserRouter,Route,Routes,redirect  } from 'react-router-dom';
import Register from './page/Register';
import Login from './page/Login';
import { useState } from 'react';
function App() {
  const [IsAuth,setIsAuth]=useState(false)
  return (
      <>
      
        <BrowserRouter>     
             <Routes> 
               <Route path='/register' element={<Register/>}></Route>
               <Route path='/login' element={<Login/>}></Route>
               <Route path='/' element={<Login/>}></Route>
               <Route path='/home' element={<Home/>}>
                    
               </Route>
               {/* {IsAuth ? <redirect to="/" /> : <Login />} */}
            </Routes>
        </BrowserRouter>
           

      </>
  );
}

export default App;
